<template>
	<div>
        <div class="row">
            <div class="col-md-3"><h1>{{ $t("absences") }}</h1></div>
            <div class="col-md-9">
                <div class="d-flex flex-row align-items-end flex-wrap float-right" style="gap: 1rem" >
                    <SelectInput 
                        :label="$t('location')" 
                        v-model="ttroom_id" 
                        :options="ttrooms"
                        optionValue="ttroom_id"
						optionLabel="ttroom_name"
                        :nullLabel="$t('any')"
                        :nullable="true"
                        @input="getAbsences()"
                    />
                    <DateInput :label="$t('from')" v-model="datetime.from" @input="getAbsences()"/>
                    <DateInput :label="$t('to')" v-model="datetime.to" @input="getAbsences()" />
                </div>
            </div>
        </div>
		<div class="list-group">
			<div
				class="list-group-item"
				v-for="(absence, index) in absences"
				v-bind:key="index"
			>
				<p class="mb-0"><strong>{{absence.ttsessiontype_name}} | {{absence.ttroom_name}}</strong></p>
				<p class="mb-0">{{absence.ttevent_notes}}</p>
				<p class="mb-0">{{$datetime.timestampToDate(absence.ttevent_datetimefrom)}} {{$datetime.timestampToTime(absence.ttevent_datetimefrom, false)}} - {{$datetime.timestampToTime(absence.ttevent_datetimeto, false)}}</p>
				<p class="mb-0">
					{{absence.displayName}}
					<template v-if="absence.studentid"> | {{ $t('id-colon') }} {{ absence.studentid }}</template>
					<template v-if="absence.programme"> | {{ $t('programme-colon') }} {{ $config.getProgrammeNameById(absence.programme) }}</template>
					<template v-if="absence.year">
						<button class="btn btn-light btn-sm ml-2" @click="inspectYear(absence)">{{ $t('year-colon') }} {{ absence.year }}</button>
					</template>
					<template v-if="absence.group">
					<button class="btn btn-light btn-sm ml-2" @click="inspectGroup(absence)">{{ $t('group-colon') }}{{ $config.getGroupNameById(absence.group) }}</button>
					</template>
					<template v-if="absence.firm">
						<button class="btn btn-light btn-sm ml-2" @click="inspectFirm(absence)">{{ $t('firm-colon') }} {{ $config.getFirmNameById(absence.firm) }}</button>
					</template>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import DateInput from "src/components/Inputs/DateInput";

export default {
	components: {
        DateInput
	},
	data() {
        const today = new Date();
        const future = new Date(today);
        future.setDate(today.getDate() + 7);

		return {
			absences: [],
            datetime: {
                from: today.toISOString().split('T')[0],
                to: future.toISOString().split('T')[0]
            },
            ttroom_id:null,
            ttrooms:null
		}
	},
	mounted() {
		this.getAbsences();
	},
	methods: {
		getAbsences: function() {
			this.$cfetch(
			`${this.$settings.APIBaseURL}/timetable/register/gettimetableabsences` , {
				data: {
                    from: this.datetime.from,
                    to: this.datetime.to,
                    ttroom_id: this.ttroom_id
				},
                method: 'POST'
			}
			).then((json) => {
				if (json.status === "SUCCESS") {
					this.absences = json.result;
                    let ttrooms = new Set();
                    this.absences.forEach(x => {

                        const roomObj = JSON.stringify(
                            { 
                                ttroom_id: x.ttroom_id, 
                                ttroom_name: x.ttroom_name 
                            }
                        );

                        if(!ttrooms.has(roomObj)) ttrooms.add(roomObj);
                    });

                    this.ttrooms =Array.from(ttrooms).map(item =>JSON.parse(item))
				}
			});

		},
		inspectYear(absence){
			this.$router.push(`/timetables/edit/${absence.tttimetable_id}?programme=${absence.programme}&year=${absence.year}&time=${absence.ttevent_datetimefrom}`);
		},
		inspectGroup(absence){
			this.$router.push(`/timetables/edit/${absence.tttimetable_id}?programme=${absence.programme}&year=${absence.year}&group=${absence.group}&time=${absence.ttevent_datetimefrom}`);
		},
		inspectFirm(absence){
			this.$router.push(`/timetables/edit/${absence.tttimetable_id}?programme=${absence.programme}&year=${absence.year}&firm=${absence.firm}&time=${absence.ttevent_datetimefrom}`);
		}
	}
};
</script>
